var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('img',{staticClass:"mx-auto d-block width",attrs:{"src":require("../../public/images/empty-box.svg")}}),_c('h4',[_vm._v("Data not found")])])
}]

export { render, staticRenderFns }